import SectionTitle from '../../../components/SectionTitle/SectionTitle'
import './CourseRequirements.css'

export default function CourseRequirements({text, courseRequirementsTexts}) {
   const {title, subtitle} = courseRequirementsTexts;
   return (
      <div className='course-requirements-container'>
         <SectionTitle upText={subtitle} downText={title} />
         <p className='course-requirements-description'>
             {text}
         </p>
      </div>
   )
}
